module.exports = __webpack_public_path__ + "static/media/Tesla.8ed7561c.jpg";